import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import Image from 'next/image';

export default function Footer() {
  return (
    <footer className="border-t border-white/5 py-10 px-6">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <AppLogo size={20} text="MasteringSWOT" className="text-foreground/50" />

        <div className="flex items-center gap-6 text-sm font-medium text-foreground/40">
          <a href="#overview" className="hover:text-foreground/80 transition-colors">Overview</a>
          <a href="#learn" className="hover:text-foreground/80 transition-colors">What You&apos;ll Learn</a>
          <a href="#preview" className="hover:text-foreground/80 transition-colors">Preview</a>
          <a href="#download" className="hover:text-foreground/80 transition-colors">Download</a>
        </div>

        <div className="flex flex-col items-center sm:items-end gap-3">
          <a
            href="https://www.thestrategyshelf.com"
            target="_blank"
            rel="noopener noreferrer"
            className="opacity-80 hover:opacity-100 transition-opacity"
          >
            <Image
              src="/assets/images/Logo_final-1772277182605.png"
              alt="The Strategy Shelf"
              width={140}
              height={48}
              className="object-contain"
            />
          </a>
          <div className="flex items-center gap-4 text-xs text-foreground/30">
            <a href="#" className="hover:text-foreground/60 transition-colors">Privacy</a>
            <span>·</span>
            <a href="#" className="hover:text-foreground/60 transition-colors">Terms</a>
            <span>·</span>
            <span>© 2026 MasteringSWOT</span>
          </div>
        </div>
      </div>
    </footer>
  );
}